export const SEARCH_PROJECT_ASYNC = 'SEARCH_PROJECT_ASYNC';
export const SEARCH_PROJECT_SUCCESS = 'SEARCH_PROJECT_SUCCESS';
export const CREATE_PROJECT_ASYNC = 'CREATE_PROJECT_ASYNC';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_ASYNC = 'UPDATE_PROJECT_ASYNC';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const GET_PROJECT_BY_ID_ASYNC = 'GET_PROJECT_BY_ID_ASYNC';
export const GET_PROJECT_BY_ID_SUCCESS = 'GET_PROJECT_BY_ID_SUCCESS';
export const CREATE_UPDATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';
export const RESET_PROJECT = 'RESET_PROJECT';
export const SELECT_LIST_PROJECT_ASYNC = 'SELECT_LIST_PROJECT_ASYNC';
export const SELECT_LIST_PROJECT_SUCCESS = 'SELECT_LIST_PROJECT_SUCCESS';
export const SELECT_LIST_LOT_ASYNC = 'SELECT_LIST_LOT_ASYNC';
export const SELECT_LIST_LOT_SUCCESS = 'SELECT_LIST_LOT_SUCCESS';
export const GET_LIST_PROJECT_ASSIGNMENT_USER_ASYNC =
  'GET_LIST_PROJECT_ASSIGNMENT_USER_ASYNC';
export const GET_LIST_PROJECT_ASSIGNMENT_USER_SUCCESS =
  'GET_LIST_PROJECT_ASSIGNMENT_USER_SUCCESS';
export const ASSIGN_USER_TO_PROJECT_ASYNC = 'ASSIGN_USER_TO_PROJECT_ASYNC';
export const ASSIGN_USER_TO_PROJECT_SUCCESS = 'ASSIGN_USER_TO_PROJECT_SUCCESS';
export const GET_LIST_BUILDER_USER_ASYNC = 'GET_LIST_BUILDER_USER_ASYNC';
export const GET_LIST_BUILDER_USER_SUCCESS = 'GET_LIST_BUILDER_USER_SUCCESS';
export const GET_LIST_USER_ASYNC = 'GET_LIST_USER_ASYNC';
export const GET_LIST_USER_SUCCESS = 'GET_LIST_USER_SUCCESS';
export const RESET_BUILDER_USER_LIST = 'RESET_BUILDER_USER_LIST';

//Phase constants
export const SEARCH_PHASE_ASYNC = 'SEARCH_PHASE_ASYNC';
export const SEARCH_PHASE_SUCCESS = 'SEARCH_PHASE_SUCCESS';
export const CREATE_PHASE_ASYNC = 'CREATE_PHASE_ASYNC';
export const UPDATE_PHASE_ASYNC = 'UPDATE_PHASE_ASYNC';
export const UPDATE_PHASE_SUCCESS = 'UPDATE_PHASE_SUCCESS';
export const DELETE_PHASE_ASYNC = 'DELETE_PHASE_ASYNC';
export const GET_PHASE_BY_ID_ASYNC = 'GET_PHASE_BY_ID_ASYNC';
export const GET_PHASE_BY_ID_SUCCESS = 'GET_PHASE_BY_ID_SUCCESS';
export const CREATE_UPDATE_PHASE_ERROR = 'CREATE_PHASE_ERROR';
export const RESET_PHASE = 'RESET_PHASE';
export const GET_LIST_PHASE_BY_PROJECT_ASYNC =
  'GET_LIST_PHASE_BY_PROJECT_ASYNC';
export const GET_LIST_PHASE_BY_PROJECT_SUCCESS =
  'GET_LIST_PHASE_BY_PROJECT_SUCCESS';

// Assignee notice
export const SETTING_UPDATE_ASSIGNEE_NOTICE_ASYNC =
  'SETTING_UPDATE_ASSIGNEE_NOTICE_ASYNC';
export const SETTING_UPDATE_ASSIGNEE_NOTICE_SUCCESS =
  'SETTING_UPDATE_ASSIGNEE_NOTICE_SUCCESS';
export const GET_SETTING_ASSIGNEE_NOTICE_BY_PROJECT_ASYNC =
  'GET_SETTING_ASSIGNEE_NOTICE_BY_PROJECT_ASYNC';
export const CREATE_ASSIGNEE_NOTICE_RESET = 'CREATE_ASSIGNEE_NOTICE_RESET';

export const SELECT_SUBCONTRACTOR_LIST_PROJECT_ASYNC =
  'SELECT_SUBCONTRACTOR_LIST_PROJECT_ASYNC';

export const SELECT_BUILDER_LIST_PROJECT_ASYNC =
  'SELECT_BUILDER_LIST_PROJECT_ASYNC';

//Project setting
export const GET_PROJECT_SETTING_ASYNC = 'GET_PROJECT_SETTING_ASYNC';
export const GET_PROJECT_SETTING_SUCCESS = 'GET_PROJECT_SETTING_SUCCESS';
export const UPDATE_PROJECT_SETTING_ASYNC = 'UPDATE_PROJECT_SETTING_ASYNC';
export const GET_PROJECT_SETTING_NOTICE_RFS_ASYNC =
  'GET_PROJECT_SETTING_NOTICE_RFS_ASYNC';
export const GET_PROJECT_SETTING_NOTICE_RFS_SUCCESS =
  'GET_PROJECT_SETTING_NOTICE_RFS_SUCCESS';
export const UPDATE_PROJECT_SETTING_NOTICE_RFS_ASYNC =
  'UPDATE_PROJECT_SETTING_NOTICE_RFS_ASYNC';

export const GET_PROJECT_BY_USER_ID_ASYNC = 'GET_PROJECT_BY_USER_ID_ASYNC';
export const GET_PROJECT_BY_USER_ID_SUCCESS = 'GET_PROJECT_BY_USER_ID_SUCCESS';

export const REASSIGN_PROJECT_OWNER_ASYNC = 'REASSIGN_PROJECT_OWNER_ASYNC';
export const REASSIGN_PROJECT_OWNER_SUCCESS = 'REASSIGN_PROJECT_OWNER_SUCCESS';

export const REASSIGN_PROJECT_COORDINATOR_ASYNC =
  'REASSIGN_PROJECT_COORDINATOR_ASYNC';
export const REASSIGN_PROJECT_COORDINATOR_SUCCESS =
  'REASSIGN_PROJECT_COORDINATOR_SUCCESS';

//Project Document
export const GET_LIST_PROJECT_DOCUMENT_TYPE_ASYNC =
  'GET_LIST_PROJECT_DOCUMENT_TYPE_ASYNC';
export const GET_LIST_PROJECT_DOCUMENT_TYPE_SUCCESS =
  'GET_LIST_PROJECT_DOCUMENT_TYPE_SUCCESS';
export const GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC =
  'GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC';
export const GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS =
  'GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS';
export const UPLOAD_PROJECT_DOCUMENT_TO_SERVER_ASYNC =
  'UPLOAD_PROJECT_DOCUMENT_TO_SERVER_ASYNC';
export const UPLOAD_PROJECT_DOCUMENT_TO_SERVER_SUCCESS =
  'UPLOAD_PROJECT_DOCUMENT_TO_SERVER_SUCCESS';
export const REMOVE_PROJECT_DOCUMENT_ASYNC = 'REMOVE_PROJECT_DOCUMENT_ASYNC';
export const UPDATE_PROJECT_DOCUMENT_NAME_ASYNC =
  'UPDATE_PROJECT_DOCUMENT_NAME_ASYNC';
export const GET_PROJECT_DOCUMENT_SHARE_LOT_ASYNC =
  'GET_PROJECT_DOCUMENT_SHARE_LOT_ASYNC';
export const GET_PROJECT_DOCUMENT_SHARE_LOT_SUCCESS =
  'GET_PROJECT_DOCUMENT_SHARE_LOT_SUCCESS';
export const UPDATE_PROJECT_DOCUMENT_SHARE_LOT_ASYNC =
  'UPDATE_PROJECT_DOCUMENT_SHARE_LOT_ASYNC';
export const UPDATE_PROJECT_DOCUMENT_SHARE_LOT_SUCCESS =
  'UPDATE_PROJECT_DOCUMENT_SHARE_LOT_SUCCESS';
export const UPDATE_HOMEOWNER_MANUAL_FOLDER_TITLE_ASYNC =
  'UPDATE_HOMEOWNER_MANUAL_FOLDER_TITLE_ASYNC';

export const EXPORT_PROJECT_LIST = 'EXPORT_PROJECT_LIST';

//Custom Template
export const GET_LIST_DEFAULT_CUSTOM_TEMPLATE_ASYNC = 'GET_LIST_DEFAULT_CUSTOM_TEMPLATE_ASYNC';
export const GET_LIST_DEFAULT_CUSTOM_TEMPLATE_SUCCESS = 'GET_LIST_DEFAULT_CUSTOM_TEMPLATE_SUCCESS';

export const SELECT_CUSTOM_TEMPLATE_ASYNC = 'SELECT_CUSTOM_TEMPLATE_ASYNC';
export const SELECT_CUSTOM_TEMPLATE_SUCCESS = 'SELECT_CUSTOM_TEMPLATE_SUCCESS';

export const CREATE_NEW_PROJECT_EOC_TEMPLATE_ASYNC = 'CREATE_NEW_PROJECT_EOC_TEMPLATE_ASYNC';
export const CREATE_NEW_PROJECT_EPL_TEMPLATE_ASYNC = 'CREATE_NEW_PROJECT_EPL_TEMPLATE_ASYNC';

export const GET_CUSTOM_TEMPLATE_DETAIL_ASYNC = 'GET_CUSTOM_TEMPLATE_DETAIL_ASYNC';
export const GET_CUSTOM_TEMPLATE_DETAIL_SUCCESS = 'GET_CUSTOM_TEMPLATE_DETAIL_SUCCESS';

export const EDIT_CUSTOM_TEMPLATE_ASYNC = 'EDIT_CUSTOM_TEMPLATE_ASYNC';
export const EDIT_EPL_TEMPLATE_ASYNC = 'EDIT_EPL_TEMPLATE_ASYNC';

export const DUPLICATE_EOC_TEMPLATE_ASYNC = 'DUPLICATE_EOC_TEMPLATE_ASYNC';
export const DUPLICATE_EOC_TEMPLATE_SUCCESS = 'DUPLICATE_EOC_TEMPLATE_SUCCESS';

export const COPY_EOC_TEMPLATE_ASYNC = 'COPY_EOC_TEMPLATE_ASYNC';
export const COPY_EOC_TEMPLATE_SUCCESS = 'COPY_EOC_TEMPLATE_SUCCESS';

export const COPY_EOF_TEMPLATE_ASYNC = 'COPY_EOF_TEMPLATE_ASYNC';
export const COPY_EOF_TEMPLATE_SUCCESS = 'COPY_EOF_TEMPLATE_SUCCESS';

export const GET_LIST_COPY_EOC_TEMPLATE_LIST_ASYNC = 'GET_LIST_COPY_EOC_TEMPLATE_LIST_ASYNC';
export const GET_LIST_COPY_EOC_TEMPLATE_LIST_SUCCESS = 'GET_LIST_COPY_EOC_TEMPLATE_LIST_SUCCESS';

//IMPORT
export const IMPORT_RFS_TO_PROJECT_ASYNC = 'IMPORT_RFS_TO_PROJECT_ASYNC';
export const IMPORT_RFS_TO_PROJECT_SUCCESS = 'IMPORT_RFS_TO_PROJECT_SUCCESS';
export const GET_IMPORT_STATUS_BY_PROJECT_ASYNC =
  'GET_IMPORT_STATUS_BY_PROJECT_ASYNC';
export const GET_IMPORT_STATUS_BY_PROJECT_SUCCESS =
  'GET_IMPORT_STATUS_BY_PROJECT_SUCCESS';
export const IMPORT_WORK_ORDER_TO_PROJECT_ASYNC =
  'IMPORT_WORK_ORDER_TO_PROJECT_ASYNC';
export const IMPORT_WORK_ORDER_TO_PROJECT_SUCCESS =
  'IMPORT_WORK_ORDER_TO_PROJECT_SUCCESS';
export const IMPORT_PURCHASE_ORDER_TO_PROJECT_ASYNC =
  'IMPORT_PURCHASE_ORDER_TO_PROJECT_ASYNC';
export const IMPORT_PURCHASE_ORDER_TO_PROJECT_SUCCESS =
  'IMPORT_PURCHASE_ORDER_TO_PROJECT_SUCCESS';
export const GET_BUILDER_NAME_ASYNC = 'GET_BUILDER_NAME_ASYNC';
export const GET_BUILDER_NAME_SUCCESS = 'GET_BUILDER_NAME_SUCCESS';

//HOME INVENTORY
export const CREATE_NEW_CATEGORY_ASYNC = 'CREATE_NEW_CATEGORY_ASYNC';
export const CREATE_NEW_CATEGORY_ERROR = 'CREATE_NEW_CATEGORY_ERROR';
export const SUGGEST_INFORMATION_CATEGORY_ASYNC = 'SUGGEST_INFORMATION_CATEGORY_ASYNC';
export const SUGGEST_INFORMATION_CATEGORY_SUCCESS = 'SUGGEST_INFORMATION_CATEGORY_SUCCESS';
export const GET_LIST_CATEGORY_ASYNC = 'GET_LIST_CATEGORY_ASYNC';
export const GET_LIST_CATEGORY_SUCCESS = 'GET_LIST_CATEGORY_SUCCESS';

export const GET_CATEGORY_PROFILE_DETAILS_ASYNC = 'GET_CATEGORY_PROFILE_DETAILS_ASYNC';
export const GET_CATEGORY_PROFILE_DETAILS_SUCCESS = 'GET_CATEGORY_PROFILE_DETAILS_SUCCESS';

export const GET_LIST_CATEGORY_PROFILE_IMAGES_ASYNC = 'GET_LIST_CATEGORY_PROFILE_IMAGES_ASYNC';
export const GET_LIST_CATEGORY_PROFILE_IMAGES_SUCCESS = 'GET_LIST_CATEGORY_PROFILE_IMAGES_SUCCESS';

export const EDIT_CATEGORY_PROFILE_ASYNC = 'EDIT_CATEGORY_PROFILE_ASYNC';

export const GET_SELECTED_TEMPLATE_CATEGORY_ASYNC = 'GET_SELECTED_TEMPLATE_CATEGORY_ASYNC';
export const GET_SELECTED_TEMPLATE_CATEGORY_SUCCESS = 'GET_SELECTED_TEMPLATE_CATEGORY_SUCCESS';

export const EDIT_CATEGORY_IMAGE_ASYNC = 'EDIT_CATEGORY_IMAGE_ASYNC';
export const DELETE_CATEGORY_IMAGE_ASYNC = 'DELETE_CATEGORY_IMAGE_ASYNC';
export const DELETE_CATEGORY_ITEM_ASYNC = 'DELETE_CATEGORY_ITEM_ASYNC';

export const CREATE_NEW_INVENTORY_ITEM_ASYNC = 'CREATE_NEW_INVENTORY_ITEM_ASYNC';
export const CREATE_NEW_INVENTORY_ITEM_SUCCESS = 'CREATE_NEW_INVENTORY_ITEM_SUCCESS';

export const GET_LIST_CATEGORY_DROPDOWN_ASYNC = 'GET_LIST_CATEGORY_DROPDOWN_ASYNC';
export const GET_LIST_CATEGORY_DROPDOWN_SUCCESS = 'GET_LIST_CATEGORY_DROPDOWN_SUCCESS';

export const GET_LIST_INVENTORY_ITEM_ASYNC = 'GET_LIST_INVENTORY_ITEM_ASYNC';
export const GET_LIST_INVENTORY_ITEM_SUCCESS = 'GET_LIST_INVENTORY_ITEM_SUCCESS';

export const GET_INVENTORY_ITEM_PROFILE_ASYNC = 'GET_INVENTORY_ITEM_PROFILE_ASYNC';
export const GET_INVENTORY_ITEM_PROFILE_SUCCESS = 'GET_INVENTORY_ITEM_PROFILE_SUCCESS';

export const GET_INVENTORY_ITEM_IMAGES_ASYNC = 'GET_INVENTORY_ITEM_IMAGES_ASYNC';
export const GET_INVENTORY_ITEM_IMAGES_SUCCESS = 'GET_INVENTORY_ITEM_IMAGES_SUCCESS';

export const GET_INVENTORY_ITEM_ATTACHMENT_ASYNC = 'GET_INVENTORY_ITEM_ATTACHMENT_ASYNC';
export const GET_INVENTORY_ITEM_ATTACHMENT_SUCCESS = 'GET_INVENTORY_ITEM_ATTACHMENT_SUCCESS';

export const DELETE_INVENTORY_ITEM_IMAGES_ASYNC = 'DELETE_INVENTORY_ITEM_IMAGES_ASYNC';
export const DELETE_INVENTORY_ITEM_ATTACHMENT_ASYNC = 'DELETE_INVENTORY_ITEM_ATTACHMENT_ASYNC';

export const ADD_INVENTORY_ITEM_IMAGES_ASYNC = 'ADD_INVENTORY_ITEM_IMAGES_ASYNC';

export const DELETE_INVENTORY_ITEM_ASYNC = 'DELETE_INVENTORY_ITEM_ASYNC';

export const EDIT_INVENTORY_ITEM_ASYNC = 'EDIT_INVENTORY_ITEM_ASYNC';

export const GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_ASYNC = 'GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_ASYNC';
export const GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_SUCCESS = 'GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_SUCCESS';

export const ASSIGN_PLAN_TO_LOT_INVENTORY_ITEM_ASYNC = 'ASSIGN_PLAN_TO_LOT_INVENTORY_ITEM_ASYNC';

export const GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_ASYNC = 'GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_ASYNC';
export const GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_SUCCESS = 'GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_SUCCESS';

export const UPDATE_LOT_LIST_INVENTORY_ASYNC = 'UPDATE_LOT_LIST_INVENTORY_ASYNC';
export const DELETE_LOT_LIST_INVENTORY_ITEM_ASYNC = 'DELETE_LOT_LIST_INVENTORY_ITEM_ASYNC';

export const GET_SUGGEST_TEMPLATE_NAME_ASYNC = 'GET_SUGGEST_TEMPLATE_NAME_ASYNC';
export const GET_SUGGEST_TEMPLATE_NAME_SUCCESS = 'GET_SUGGEST_TEMPLATE_NAME_SUCCESS';

export const GET_SUGGEST_DATA_ASYNC = 'GET_SUGGEST_DATA_ASYNC';
export const GET_SUGGEST_DATA_SUCCESS = 'GET_SUGGEST_DATA_SUCCESS';

export const SUGGEST_LOCATION_TAGS_HOME_INVENTORY_ASYNC = 'SUGGEST_LOCATION_TAGS_HOME_INVENTORY_ASYNC';
export const SUGGEST_LOCATION_TAGS_HOME_INVENTORY_SUCCESS = 'SUGGEST_LOCATION_TAGS_HOME_INVENTORY_SUCCESS';
//loading attachments
export const SETUP_PROJECT_DOCUMENT_AWS_ASYNC = 'SETUP_PROJECT_DOCUMENT_AWS_ASYNC';
export const SETUP_PROJECT_DOCUMENT_AWS_SUCCESS = 'SETUP_PROJECT_DOCUMENT_AWS_SUCCESS';

export const UPLOAD_PROJECT_DOCUMENT_TO_S3_ASYNC = 'UPLOAD_PROJECT_DOCUMENT_TO_S3_ASYNC';

export const ADD_INVENTORY_ITEM_ATTACHMENT_ASYNC = 'ADD_INVENTORY_ITEM_ATTACHMENT_ASYNC';

export const GET_INVENTORY_TEMPLATE_LIST_ASYNC = 'GET_INVENTORY_TEMPLATE_LIST_ASYNC';
export const GET_INVENTORY_TEMPLATE_LIST_SUCCESS = 'GET_INVENTORY_TEMPLATE_LIST_SUCCESS';

export const POST_INVENTORY_TEMPLATE_LIST_ASYNC = 'POST_INVENTORY_TEMPLATE_LIST_ASYNC';
export const POST_INVENTORY_TEMPLATE_LIST_SUCCESS = 'POST_INVENTORY_TEMPLATE_LIST_SUCCESS';

export const GET_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC = 'GET_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC';
export const GET_INVENTORY_ITEM_TEMPLATE_LIST_SUCCESS = 'GET_INVENTORY_ITEM_TEMPLATE_LIST_SUCCESS';

export const POST_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC = 'POST_INVENTORY_ITEM_TEMPLATE_LIST_ASYNC';
export const POST_INVENTORY_ITEM_TEMPLATE_LIST_SUCCESS = 'POST_INVENTORY_ITEM_TEMPLATE_LIST_SUCCESS';

export const GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_ASYNC = 'GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_ASYNC';
export const GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_SUCCESS = 'GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_SUCCESS';

export const GET_CUSTOM_TEMPLATE_DETAIL2_ASYNC = 'GET_CUSTOM_TEMPLATE_DETAIL2_ASYNC';
export const GET_CUSTOM_TEMPLATE_DETAIL2_SUCCESS = 'GET_CUSTOM_TEMPLATE_DETAIL2_SUCCESS';

export const GET_REQUEST_TYPE_TO_MAPPING_ASYNC = 'GET_REQUEST_TYPE_TO_MAPPING_ASYNC';
export const GET_REQUEST_TYPE_TO_MAPPING_SUCCESS = 'GET_REQUEST_TYPE_TO_MAPPING_SUCCESS';

export const POST_REQUEST_TYPE_TEMPLATE_ASYNC = 'POST_REQUEST_TYPE_TEMPLATE_ASYNC';
export const DELETE_REQUEST_TYPE_TEMPLATE_ASYNC = 'DELETE_REQUEST_TYPE_TEMPLATE_ASYNC';

/* Maintenance Task */
export const GET_MAINTENANCE_SETTINGS_ASYNC = 'GET_MAINTENANCE_SETTINGS_ASYNC';
export const GET_MAINTENANCE_SETTINGS_SUCCESS = 'GET_MAINTENANCE_SETTINGS_SUCCESS';

export const UPDATE_MAINTENANCE_SETTINGS_ASYNC = 'UPDATE_MAINTENANCE_SETTINGS_ASYNC';
export const UPDATE_MAINTENANCE_SETTINGS_SUCCESS = 'UPDATE_MAINTENANCE_SETTINGS_SUCCESS';

export const GET_MAINTENANCE_SETTINGS_TIMEZONE_ASYNC = 'GET_MAINTENANCE_SETTINGS_TIMEZONE_ASYNC';
export const GET_MAINTENANCE_SETTINGS_TIMEZONE_SUCCESS = 'GET_MAINTENANCE_SETTINGS_TIMEZONE_SUCCESS ';

export const CREATE_MAINTENANCE_GENERAL_TASK_ASYNC = 'CREATE_MAINTENANCE_GENERAL_TASK_ASYNC';
export const CREATE_MAINTENANCE_GENERAL_TASK_SUCCESS = 'CREATE_MAINTENANCE_GENERAL_TASK_SUCCESS';

export const UPDATE_MAINTENANCE_GENERAL_TASK_ASYNC = 'UPDATE_MAINTENANCE_GENERAL_TASK_ASYNC';
export const UPDATE_MAINTENANCE_GENERAL_TASK_SUCCESS = 'UPDATE_MAINTENANCE_GENERAL_TASK_SUCCESS';

export const CREATE_MAINTENANCE_SPECIFIC_TASK_ASYNC = 'CREATE_MAINTENANCE_SPECIFIC_TASK_ASYNC';
export const CREATE_MAINTENANCE_SPECIFIC_TASK_SUCCESS = 'CREATE_MAINTENANCE_SPECIFIC_TASK_SUCCESS';

export const UPDATE_MAINTENANCE_SPECIFIC_TASK_ASYNC = 'UPDATE_MAINTENANCE_SPECIFIC_TASK_ASYNC';
export const UPDATE_MAINTENANCE_SPECIFIC_TASK_SUCCESS = 'UPDATE_MAINTENANCE_SPECIFIC_TASK_SUCCESS';

export const GET_MAINTENANCE_GENERAL_TASK_ASYNC = 'GET_MAINTENANCE_GENERAL_TASK_ASYNC';
export const GET_MAINTENANCE_GENERAL_TASK_SUCCESS = 'GET_MAINTENANCE_GENERAL_TASK_SUCCESS';

export const GET_MAINTENANCE_SPECIFIC_TASK_ASYNC = 'GET_MAINTENANCE_SPECIFIC_TASK_ASYNC';
export const GET_MAINTENANCE_SPECIFIC_TASK_SUCCESS = 'GET_MAINTENANCE_SPECIFIC_TASK_SUCCESS';

export const GET_MAINTENANCE_LOT_LIST_ASYNC = 'GET_MAINTENANCE_LOT_LIST_ASYNC';
export const GET_MAINTENANCE_LOT_LIST_SUCCESS = 'GET_MAINTENANCE_LOT_LIST_SUCCESS';

export const GET_MAINTENANCE_TASK_LIST_ASYNC = 'GET_MAINTENANCE_TASK_LIST_ASYNC';
export const GET_MAINTENANCE_TASK_LIST_SUCCESS = 'GET_MAINTENANCE_TASK_LIST_SUCCESS';

export const DELETE_MAINTENANCE_TASK_ASYNC = 'DELETE_MAINTENANCE_TASK_ASYNC';
export const DELETE_MAINTENANCE_TASK_SUCCESS = 'DELETE_MAINTENANCE_TASK_SUCCESS';

export const GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC = 'GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC';
export const GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_SUCCESS = 'GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_SUCCESS';

export const GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_ASYNC = 'GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_ASYNC';
export const GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_SUCCESS = 'GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_SUCCESS';

export const ADD_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC = 'ADD_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC';
export const ADD_MAINTENANCE_SUGGESTED_GENERAL_TASK_SUCCESS = 'ADD_MAINTENANCE_SUGGESTED_GENERAL_TASK_SUCCESS';

export const GET_MAINTENANCE_TASK_REMINDER_LIST_ASYNC = 'GET_MAINTENANCE_TASK_REMINDER_LIST_ASYNC';
export const GET_MAINTENANCE_TASK_REMINDER_LIST_SUCCESS = 'GET_MAINTENANCE_TASK_REMINDER_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/Projects/constants.js